
<div class="table table-striped">
  <p-table #dt [value]="contingentes" [rows]="10" [paginator]="true" [globalFilterFields]="['claseContingenteNavigation.descripcion']"
            [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Contingentes" [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
      <div class="p-d-flex p-ai-center p-jc-between">
        <span class="p-input-icon-left">
          <!-- <i class="pi pi-search"></i> -->
          <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
        </span>
        <span class="p-input-icon">
          Vigencias del  
          <input pInputText type="date" [(ngModel)]="filtroDesde" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
          al  
          <input pInputText type="date" [(ngModel)]="filtroHasta" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
        </span>
        <mat-slide-toggle color="primary" [(ngModel)]="agrupar" (ngModelChange)="onChangeAgrupamiento()">Agrupar</mat-slide-toggle>
        <button *ngIf="permisoEdicion" type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Clase Contingente</th>
        <th>Fecha Desde</th>
        <th>Fecha Hasta</th>
        <th>Cantidad</th>
        <th>Inicio Liquidación</th>
        <th>Fin Liquidación</th>
        <th>Días Consumidos</th>
        <th>Días Pendientes</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-contingente let-rowIndex="rowIndex">
      <tr>
        <td>{{contingente.claseContingenteNavigation.descripcion}}</td>
        <td class="text-center">{{contingente.desde|date:'dd/MM/yyyy'}}</td>
        <td class="text-center">{{contingente.hasta|date:'dd/MM/yyyy'}}</td>
        <td class="text-right">{{contingente.cantidad}}</td>
        <td class="text-center">{{contingente.inicioLiquidacion|date:'dd/MM/yyyy'}}</td>
        <td class="text-center">{{contingente.finLiquidacion|date:'dd/MM/yyyy'}}</td>
        <td class="text-right">{{contingente.diasConsumidos}}</td>
        <td class="text-right">{{contingente.cantidad - contingente.diasConsumidos}}</td>
        <td>
          <button pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="visualizarDetalle(contingente, rowIndex)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
